import "core-js/modules/es.array.reverse.js";
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import { autorun, observable, makeObservable } from "mobx";
import { USER_ADDED_CATEGORY_ID } from "../../Core/addedByUser";
import CatalogGroup from "./CatalogGroup";
import CommonStrata from "../Definition/CommonStrata";
import { BaseModel } from "../Definition/Model";
import isDefined from "../../Core/isDefined";
let Catalog = (_class = class Catalog {
  constructor(terria) {
    _initializerDefineProperty(this, "group", _descriptor, this);
    _defineProperty(this, "terria", void 0);
    _defineProperty(this, "_disposeCreateUserAddedGroup", void 0);
    makeObservable(this);
    this.terria = terria;
    this.group = new CatalogGroup("/", this.terria);
    this.terria.addModel(this.group);
    this._disposeCreateUserAddedGroup = autorun(() => {
      // Make sure the catalog has a user added data group even if its
      // group or group members are reset.
      if (!this.group.memberModels.find(m => m.uniqueId === USER_ADDED_CATEGORY_ID)) {
        let userAddedDataGroup = this.terria.getModelById(BaseModel, USER_ADDED_CATEGORY_ID);
        if (!isDefined(userAddedDataGroup)) {
          userAddedDataGroup = new CatalogGroup(USER_ADDED_CATEGORY_ID, this.terria);
          const userAddedGroupName = i18next.t("core.userAddedData");
          userAddedDataGroup.setTrait(CommonStrata.definition, "name", userAddedGroupName);
          const userAddedGroupDescription = i18next.t("models.catalog.userAddedDataGroup");
          userAddedDataGroup.setTrait(CommonStrata.definition, "description", userAddedGroupDescription);
          this.terria.addModel(userAddedDataGroup);
        }
        this.group.add(CommonStrata.definition, userAddedDataGroup);
      }
    });
  }
  destroy() {
    this._disposeCreateUserAddedGroup();
  }
  get userAddedDataGroup() {
    const group = this.group.memberModels.find(m => m.uniqueId === USER_ADDED_CATEGORY_ID);
    return group;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "group", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Catalog as default };